import React from "react";
import PropTypes from "prop-types";

import {
    Button,
    Card,
    Space,
    Tag,
    Typography
} from "antd";

import {
    MessageOutlined
} from "@ant-design/icons";

import { subCategoryLabel } from "../../../../../constants/subCategoryLabels";

const { Text } = Typography;

const formatDay = (value) =>
    new Date(value).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric"
    });

/**
 * Titre selon le rôle du destinataire dans la conversation :
 * « Vente de céréales – 01 octobre 2026 » pour le vendeur,
 * « Achat de céréales – 01 octobre 2026 » pour l'acheteur.
 */
const buildTitle = (notification) => {
    const action = notification.viewerRole === "SELLER"
        ? "Vente"
        : notification.viewerRole === "BUYER"
            ? "Achat"
            : null;

    if (!action) {
        return notification.title || "Nouvelle conversation";
    }

    const subCategory = subCategoryLabel(notification.subCategoryName);
    const openedAt = notification.conversationOpenedAt || notification.createdAt;

    return [
        subCategory ? `${action} de ${subCategory}` : action,
        openedAt ? formatDay(openedAt) : null
    ].filter(Boolean).join(" – ");
};

const ConversationNotificationCard = ({
                                          notification,
                                          onOpenConversation,
                                          onMarkAsRead
                                      }) => {

    const handleOpen = () => {

        if (!notification?.read && onMarkAsRead) {
            onMarkAsRead(notification.id);
        }

        if (onOpenConversation) {
            onOpenConversation(notification);
        }
    };

    const formattedDate = notification?.createdAt
        ? new Date(notification.createdAt).toLocaleString(
            "fr-FR",
            {
                day: "2-digit",
                month: "long",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            }
        )
        : null;

    return (
        <Card
            style={{
                marginBottom: 15,
                borderRadius: 12,
                cursor: "pointer"
            }}
            onClick={handleOpen}
        >
            <Space
                direction="vertical"
                size={8}
                style={{ width: "100%" }}
            >

                <Space>
                    <MessageOutlined />

                    <Text strong>
                        {buildTitle(notification)}
                    </Text>

                    {!notification.read && (
                        <Tag color="blue">
                            Nouveau
                        </Tag>
                    )}
                </Space>

                {notification.otherPartyRole && (
                    <Text>
                        {notification.otherPartyRole === "BUYER"
                            ? "Acheteur"
                            : "Vendeur"
                        }

                        {notification.otherPartyCompanyName && (
                            <>
                                {" : "}
                                <Text strong>
                                    {notification.otherPartyCompanyName}
                                </Text>
                            </>
                        )}
                    </Text>
                )}

                <Text>
                    Produit :{" "}
                    <Text strong>
                        {notification.productName ||
                            "Produit indisponible"}
                    </Text>
                </Text>

                {formattedDate && (
                    <Text type="secondary">
                        {formattedDate}
                    </Text>
                )}

                <Button
                    type="link"
                    style={{ padding: 0 }}
                    onClick={(event) => {
                        event.stopPropagation();
                        handleOpen();
                    }}
                >
                    Ouvrir la conversation
                </Button>

            </Space>
        </Card>
    );
};

ConversationNotificationCard.propTypes = {
    notification: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        read: PropTypes.bool,
        createdAt: PropTypes.string,
        viewerRole: PropTypes.oneOf(["BUYER", "SELLER"]),
        otherPartyRole: PropTypes.oneOf(["BUYER", "SELLER"]),
        otherPartyCompanyName: PropTypes.string,
        productName: PropTypes.string,
        subCategoryName: PropTypes.string,
        conversationOpenedAt: PropTypes.string
    }).isRequired,
    onOpenConversation: PropTypes.func,
    onMarkAsRead: PropTypes.func
};

export default ConversationNotificationCard;